<template>
  <v-dialog scrollable persistent v-model="newAccountFormDialog" max-width="750px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            small
            top
            right
            color="primary"
            @click="openDialogForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar conta</span>
      </v-tooltip>
      <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeDialogForm">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >{{formData.id ? 'Editar conta' : 'Nova conta'}}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <v-form ref="newAccountForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-tabs class="pt-3" v-model="active" color="white" slider-color="primary">
            <v-tab>Dados da conta</v-tab>
            <v-tab>Marcadores</v-tab>
            <v-tab-item>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      class="selectOverflowHiden"
                      :rules="$store.state.formRules.requiredSelect"
                      v-model="formData.condominium_id"
                      :items="condominiumsList"
                      item-text="name_fantasy"
                      item-value="id"
                      @change="getIndex"
                      label="Selecione o condomínio"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      class="pt-2"
                      v-model="formData.financial_id"
                      :items="financialList"
                      :disabled="!formData.condominium_id"
                      item-text="name"
                      item-value="id"
                      :rules="$store.state.formRules.required"
                      label="Selecione o índice da conta"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      class="pt-2"
                      v-model="formData.type_account"
                      :items="typesAccount"
                      item-text="name"
                      item-value="id"
                      :rules="$store.state.formRules.required"
                      label="Selecione o tipo da conta"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-model="formData.account_name"
                      label="Nome da conta"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      id="accountValue"
                      prefix="R$ "
                      label="Valor da conta"
                      :rules="[]"
                      v-money="$store.state.maskMoney.BRL"
                      v-model="formData.account_value"
                    ></v-text-field>
                    <!-- <v-text-field
                  v-model="formData.account_value"
                  label="Valor da conta"
                  :rules="$store.state.formRules.required"
                  required
                    ></v-text-field>-->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm6>
                    <ColorPicker
                      :editVal="formData.positive_color"
                      :autoClose="autoClose"
                      field="positive_color"
                      :updateColorField="updateColorField"
                      label="Cor para marcação positiva"
                    />
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-model="formData.positive_percentage"
                      label="Valor percentual positivo"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6>
                    <ColorPicker
                      :editVal="formData.negative_color"
                      :autoClose="autoClose"
                      field="negative_color"
                      :updateColorField="updateColorField"
                      label="Cor para marcação negativa"
                    />
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-model="formData.negative_percentage"
                      label="Valor percentual negativo"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="closeDialogForm">Cancelar</v-btn>
        <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultForm = {
  positive_color: "",
  positive_percentage: "",
  negative_color: "",
  negative_percentage: "",
  id: "",
  condominium_id: "",
  type_account: "",
  account_name: "",
  account_value: "",
  financial_id: ""
};
import { VMoney } from "v-money";
import ColorPicker from "../../ColorPicker";

export default {
  directives: {
    money: VMoney
  },
  components: {
    ColorPicker
  },
  data() {
    return {
      autoClose: false,
      active: 0,
      condominiumsList: [],
      financialList: [],
      typesAccount: [
        { name: "Débito", id: "debito" },
        { name: "Crédito", id: "credito" }
      ],
      validForm: true,
      formData: { ...defaultForm }
    };
  },
  props: {
    searchAccounts: Function,
    lastData: Object,
    newAccountFormDialog: Boolean,
    newAccountData: Object,
    openDialogForm: Function,
    closeDialogForm: Function
  },
  watch: {
    newAccountFormDialog(val) {
      if (val) {
        this.autoClose = true;
        if (this.newAccountData.id) {
          this.editAccount();
        }
      } else {
        document.getElementById("accountValue").value = "";
        this.autoClose = false;
        this.formData = { ...defaultForm };
        this.$refs.newAccountForm.resetValidation();
      }
    }
  },
  mounted() {
    console.log(process.env.VUE_APP_API_URL);
    this.getComdominiums();
  },
  methods: {
    updateColorField(val, field) {
      this.formData[field] = val;
      //console.log(this.formData.negative_color);
      //console.log(this.formData.positive_color);
    },
    editAccount() {
      console.log("88888888", this.newAccountData);
      this.formData.condominium_id = this.newAccountData.condominium_id;
      this.getIndex().then(_ => {
        this.formData = { ...this.newAccountData };
        document.getElementById(
          "accountValue"
        ).value = this.formData.account_value;
      });
    },
    async getIndex() {
      let queryParams = {};
      queryParams.params = {
        condominium_id: this.formData.condominium_id
      };

      let obj = {
        url: "/api/financial",
        query: queryParams,
        method: "get"
      };
      await this.$store.dispatch("request/doRequest", obj).then(response => {
        this.financialList = response.data;
      });
    },
    getComdominiums() {
      let obj = {
        url: "/api/condominium",
        query: "",
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.condominiumsList = response.data;
      });
    },
    doSave() {
      //console.log(this.formData);
      if (!this.$refs.newAccountForm.validate()) {
        return;
      }
      let obj = {
        url:
          "/api/financialAccount" +
          (this.formData.id ? `/${this.formData.id}` : ""),
        query: this.formData,
        method: this.formData.id ? "patch" : "post"
      };
      // let obj = {
      //   url: "/api/financialAccount",
      //   query: this.formData,
      //   method: "post"
      // };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        let obj = {
          message: `${response.data.message}`,
          title: "Sucesso",
          callback: _ => {
            if (this.lastData.financial_id) {
              this.searchAccounts(this.lastData);
            }

            this.closeDialogForm();
          },
          type: "success",
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false }
        };
        this.$store.commit("confirmMessage/showConfirmMessage", obj);
      });
    }
  }
};
</script>

<style>
</style>
